import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './styles.css';

class Checkbox extends Component {
    _onClick = () => {
      const {
        onClick, id, label, name, value, isChecked,
      } = this.props;

      onClick({
        id,
        label,
        name,
        value,
        checked: !isChecked,
      });
    }

    render() {
      const {
        id,
        className,
        isWhite,
        labelClassName,
        label,
        name,
        value,
        isChecked,
        onClick,
        circleType,
        doneType,
        right,
        onChange,
      } = this.props;

      return (
        <div
          className={
            `
              LuftCheckbox ${className || ''}
              ${circleType ? ' LuftCheckbox--circle' : ''}
              ${doneType ? ' LuftCheckbox--done' : ''}
            `
          }
          onClick={() =>
                    onClick && this._onClick()}
        >
          <input
            className={isWhite ? 'LuftCheckbox__input__white' : 'LuftCheckbox__input'}
            id={id}
            type="checkbox"
            name={name}
            value={value}
            checked={isChecked}
            onChange={() => onChange && onChange()}
          />
          <label
            className={
              `
                ${isWhite ? 'LuftCheckbox__label__white' : 'LuftCheckbox__label'}
                ${labelClassName || ''}
                ${label ? '' : ' LuftCheckbox__label--empty-label'}
              `
            }
            htmlFor={id}
          >
            {label}
          </label>
          {right && right({ id, value })}
        </div>
      );
    }
}

Checkbox.propTypes = {
  className: PropTypes.string,
  labelClassName: PropTypes.string,
  id: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.any,
  isChecked: PropTypes.bool,
  onClick: PropTypes.func,
  circleType: PropTypes.string,
  doneType: PropTypes.bool,
  right: PropTypes.bool,
  onChange: PropTypes.func,
};


export default Checkbox;
